import { ReactComponent as Download } from 'assett/icons/download.svg';
import { setDocType } from 'feature/utils/downloaderSlice';
import { useFileOpener } from 'hooks/downloader.hook';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Button, Stack } from 'styles';
import { DocType } from 'types/Upload';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import { camelcaseToUnderscore } from 'utils/utils';

export const ClaimAttachmentsDetails = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const dispatch = useDispatch();
	const fileOpener = useFileOpener();
	const { claimData: claim } = useSelector((store: RootState) => store.claim);

	const handleOpenDialog = () => {
		dispatch(setDocType('other'));
	};

	const { receipt, prescription, others } = claim.attachments;

	const attachments = [
		{ documentType: 'prescription', value: prescription },
		{ documentType: 'receipt', value: receipt },
	].filter(el => el.value);

	const handleClickDownload = (
		documentType: string,
		uuid: string | undefined,
		fileName: string | undefined,
	) => {
		if (!uuid || !fileName) return;

		const docType = camelcaseToUnderscore(documentType) as unknown as DocType;

		const url = `${
			process.env.REACT_APP_API_URL
		}/attachments/${docType}/${uuid}/content`;
		dispatch(setDocType(docType));
		fileOpener({ url, fileName });
	};

	return (
		<Stack flex={'true'} direction={'row'} gap={2.5}>
			{attachments.map(att => (
				<Button
					startIcon={<Download />}
					key={att.documentType}
					variant="outlined"
					onClick={() =>
						handleClickDownload(
							att.documentType,
							att.value?.uuid,
							att.value?.fileName,
						)
					}
				>
					{tClientLabels(`newClaim.upload.docNames.${att.documentType}`)}
				</Button>
			))}

			{others && others.length > 0 && (
				<Button
					startIcon={<Download />}
					variant="outlined"
					onClick={handleOpenDialog}
				>
					{tClientLabels(`newClaim.upload.docNames.other`)}
				</Button>
			)}
		</Stack>
	);
};
